var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative h-full w-auto bg-no-repeat bg-center bg-contain",style:({ backgroundImage: 'url(' + _vm.logo + ')' })})
}
var staticRenderFns = []

export { render, staticRenderFns }